import React from "react";
import { ReferencesDataProvider } from "../../../input-field-components/ReferencePickerField/ReferencesDataProvider";
import {
  FilterAlias,
  FilterAliasGetterContext,
} from "@adsk/acc-issues-core/providers/FilterAliasProvider";
import { withFetchParams } from "@adsk/acc-issues-core/state/issuesFetchParams/withFetchParams";
import { AppFetchParams } from "@adsk/acc-issues-core/state/issuesFetchParams/IssuesFetchParamsContext";

type FilterAliasGetter = () => Promise<FilterAlias[]>;

type IssuesTableProviderProps = {
  getFiltersAliases?: FilterAliasGetter;
  children: React.ReactElement;
};

type IssuesTableFetchParamsProps = {
  baseFilters?: AppFetchParams["filterBy"];
};

export const IssuesTableProvider: React.FC<
  IssuesTableProviderProps & IssuesTableFetchParamsProps
> = withFetchParams<IssuesTableProviderProps>({
  limit: 50,
})(({ getFiltersAliases, children }) => {
  return (
    <FilterAliasGetterContext.Provider value={getFiltersAliases ?? null}>
      <ReferencesDataProvider withIssueIds>{children}</ReferencesDataProvider>
    </FilterAliasGetterContext.Provider>
  );
});
